import { NavHeaderContainer, NavLogo, StyledLine, StyledMenu } from "./styles";
import { TbCalendarMonthFilled } from "react-icons/tb";
import { RiSettings4Fill, RiAdminFill } from "react-icons/ri";
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthInfo } from "@/features";

export const NavHeader = () => {
	const navigate = useNavigate();
	const location = useLocation();

	if(useAuthInfo().authInfo === null) window.location.href = '/signin';

	const weflo = useAuthInfo().authInfo.nickname === "위플로";
	
	const molit = useAuthInfo().authInfo.nickname === "국토교통부";
	
	const isMain = molit ? location.pathname === '/list' : location.pathname === '/main';
	const isList = location.pathname === '/list';
	const isAdmin = location.pathname === '/admin';

	return (
		<NavHeaderContainer>
			<NavLogo onClick={() => navigate(molit ? '/list' : '/main')}/>
			<StyledLine />
			
			<StyledMenu 
				onClick={() => navigate(molit ? '/list' : '/main')}
				style={{
					backgroundColor: isMain ? 'rgba(90, 30, 219, 1)' : 'transparent',
					opacity: isMain ? 1 : 0.5
				}}
			>
				<TbCalendarMonthFilled style={{ color: '#FFFFFF' }} />
			</StyledMenu>

			{weflo && (
				<StyledMenu 
					onClick={() => navigate('/list')}
					style={{
						backgroundColor: isList ? 'rgba(90, 30, 219, 1)' : 'transparent',
						opacity: isList ? 1 : 0.5
					}}
				>
					<RiSettings4Fill style={{ color: '#FFFFFF' }} />
				</StyledMenu>
			)}
			
			{weflo && (
				<StyledMenu 
					onClick={() => navigate('/admin')}
					style={{
						backgroundColor: isAdmin ? 'rgba(90, 30, 219, 1)' : 'transparent',
						opacity: isAdmin ? 1 : 0.5
					}}
				>
					<RiAdminFill style={{ color: '#FFFFFF' }} />
				</StyledMenu>
			)}
		</NavHeaderContainer>
	);
};
